import { render, staticRenderFns } from "./purchaseManagement.vue?vue&type=template&id=76eb8326"
import script from "./purchaseManagement.vue?vue&type=script&lang=js"
export * from "./purchaseManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports